import LoginContainer from "../containers/login/LoginContainer";

export default function LoginPage() {
    return (
        <LoginContainer/>
    );
}
